// extracted by mini-css-extract-plugin
export default {"action":"historyListPB_action__z64ux","list":"historyListPB_list__soWOI","divider":"historyListPB_divider__iKtuz"};